var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgInddFileIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5625 2.86719C12.979 2.86719 11.6875 1.5835 11.6875 0H2.5C1.94772 0 1.5 0.447715 1.5 1V15C1.5 15.5523 1.94772 16 2.5 16H13.5625C14.1148 16 14.5625 15.5523 14.5625 15V2.86719Z",
    fill: "url(#paint0_linear_1120_126770)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5625 2.875C12.9747 2.875 11.6875 1.58782 11.6875 0Z",
    fill: "#FF8E8E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1120_126770)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.53431 5.57568V10.1817H5.5752V5.57568H6.53431ZM8.93133 10.1817H7.32305V5.57568H8.94459C9.40076 5.57568 9.79376 5.66792 10.1232 5.85198C10.449 6.03144 10.7138 6.30672 10.8827 6.6417C11.0617 6.98489 11.151 7.39578 11.151 7.87436C11.151 8.35412 11.0613 8.7662 10.8827 9.11138C10.713 9.44836 10.4465 9.72511 10.1185 9.90505C9.78791 10.0895 9.39218 10.1817 8.93133 10.1817ZM8.28217 9.3473H8.89156C9.17501 9.3473 9.41362 9.29624 9.607 9.19451C9.80195 9.09079 9.94815 8.93127 10.0456 8.71553C10.1447 8.49782 10.1938 8.21756 10.1938 7.87436C10.1938 7.53393 10.1443 7.25565 10.0456 7.03992C9.94815 6.82379 9.80273 6.66505 9.60895 6.56292C9.41557 6.46079 9.17696 6.41013 8.89351 6.41013H8.28217V9.3473Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1120_126770",
    x1: 8.03125,
    y1: 0,
    x2: 8.03125,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F86161"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1120_126770"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.06061,
    height: 6.06061,
    fill: "white",
    transform: "translate(5.09082 4.84863)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInddFileIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/indd-file-icon.b2a1e65246c2a30ff65236927c4079bd.svg";